// src/components/BoardPackConfiguration/pages/MainTable.jsx
import React, { useState, useEffect, useRef } from "react";
import { apiCall } from "@/api/apiCall";
import LoadingComponent from "@/components/common/LoadingComponent";
import ErrorState from "@/components/common/ErrorStateComponent";
import { useQueue } from "@/context/QueueContext";
import { TableCurrentMonthYear } from "@/components/BoardPack/components/tables/TableCurrentMonthYear";

function MainTable({
  page = null,
  isExporting = false, // ✅ export mode
  cfoComment = "", // ✅ lifted state from BoardPack
  onCfoCommentChange, // ✅ setter from BoardPack
}) {
  const { enqueue } = useQueue();
//   const [cfoComments, setCfoComments] = useState("");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const hasFetchedRef = useRef(false);

  const [summary, setSummary] = useState(null);

  const is_cfo = page?.params?.is_cfo ? true : false;
  const measure = page?.params?.measure ? page?.params?.measure : 0;
  // const hasFetchedRef = useRef(false);
  const hasComment = cfoComment.trim() !== "";
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);     

      const response = {
    "success": true,
    "meta": {
        "year": 2026,
        "previousYear": 2025,
        "month": "Mar",
        "measure": 0
    },
    "data": [
        {
            "label": "Revenue",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block3": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block4": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            }
        },
        {
            "label": "DAILY PARKING",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "4,587,343",
                "Variance": "(4,587,343)",
                "Variance %": "(100%)"
            },
            "block3": {
                "Actual": "5,537,176",
                "Budget": "14,876,227",
                "Variance": "(9,339,051)",
                "Variance %": "(62.78%)"
            },
            "block4": {
                "Actual": "5,537,176",
                "Budget": "-",
                "Variance": "5,537,176",
                "Variance %": "-"
            }
        },
        {
            "label": "Season Tickets",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "2,213,895",
                "Variance": "(2,213,895)",
                "Variance %": "(100%)"
            },
            "block3": {
                "Actual": "1,948,041",
                "Budget": "6,052,817",
                "Variance": "(4,104,776)",
                "Variance %": "(67.82%)"
            },
            "block4": {
                "Actual": "1,948,041",
                "Budget": "-",
                "Variance": "1,948,041",
                "Variance %": "-"
            }
        },
        {
            "label": "Fines & Penalties",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "223,523",
                "Variance": "(223,523)",
                "Variance %": "(100%)"
            },
            "block3": {
                "Actual": "188,870",
                "Budget": "937,744",
                "Variance": "(748,874)",
                "Variance %": "(79.86%)"
            },
            "block4": {
                "Actual": "188,870",
                "Budget": "-",
                "Variance": "188,870",
                "Variance %": "-"
            }
        },
        {
            "label": "Clamp & Removal",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block3": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block4": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            }
        },
        {
            "label": "POUND",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "341,948",
                "Variance": "(341,948)",
                "Variance %": "(100%)"
            },
            "block3": {
                "Actual": "241,497",
                "Budget": "1,258,363",
                "Variance": "(1,016,866)",
                "Variance %": "(80.81%)"
            },
            "block4": {
                "Actual": "241,497",
                "Budget": "-",
                "Variance": "241,497",
                "Variance %": "-"
            }
        },
        {
            "label": "OTHER INCOME",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "348,370",
                "Variance": "(348,370)",
                "Variance %": "(100%)"
            },
            "block3": {
                "Actual": "814,580",
                "Budget": "1,004,351",
                "Variance": "(189,771)",
                "Variance %": "(18.89%)"
            },
            "block4": {
                "Actual": "814,580",
                "Budget": "-",
                "Variance": "814,580",
                "Variance %": "-"
            }
        },
        {
            "label": "CASH EXCESS / (SHORT)",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "536",
                "Variance": "(536)",
                "Variance %": "(100%)"
            },
            "block3": {
                "Actual": "(4,422)",
                "Budget": "1,253",
                "Variance": "(5,675)",
                "Variance %": "(453.04%)"
            },
            "block4": {
                "Actual": "(4,422)",
                "Budget": "-",
                "Variance": "(4,422)",
                "Variance %": "-"
            }
        },
        {
            "label": "Validations",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block3": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block4": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            }
        },
        {
            "label": "Refunds",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block3": {
                "Actual": "-",
                "Budget": "(6,239)",
                "Variance": "6,239",
                "Variance %": "100%"
            },
            "block4": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            }
        },
        {
            "label": "WRAPPING BUSINESS",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block3": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block4": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            }
        },
        {
            "label": "Total Revenue",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "7,715,614",
                "Variance": "(7,715,614)",
                "Variance %": "(100%)"
            },
            "block3": {
                "Actual": "8,725,742",
                "Budget": "24,124,516",
                "Variance": "(15,398,774)",
                "Variance %": "(63.83%)"
            },
            "block4": {
                "Actual": "8,725,742",
                "Budget": "-",
                "Variance": "8,725,742",
                "Variance %": "-"
            }
        },
        {
            "label": "Total Rent",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "(3,813,596)",
                "Variance": "3,813,596",
                "Variance %": "100%"
            },
            "block3": {
                "Actual": "(4,365,082)",
                "Budget": "(11,921,201)",
                "Variance": "7,556,120",
                "Variance %": "63.38%"
            },
            "block4": {
                "Actual": "(4,365,082)",
                "Budget": "-",
                "Variance": "(4,365,082)",
                "Variance %": "-"
            }
        },
        {
            "label": "Rent V Revenue %",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "49.43%",
                "Variance": "-",
                "Variance %": "-"
            },
            "block3": {
                "Actual": "50.03%",
                "Budget": "49.42%",
                "Variance": "-",
                "Variance %": "0.61%"
            },
            "block4": {
                "Actual": "50.03%",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            }
        },
        {
            "label": "Staff Cost-Direct %",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "1.77%",
                "Variance": "-",
                "Variance %": "-"
            },
            "block3": {
                "Actual": "1.75%",
                "Budget": "1.59%",
                "Variance": "-",
                "Variance %": "0.16%"
            },
            "block4": {
                "Actual": "1.75%",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            }
        },
        {
            "label": "Total Staff Cost - Direct",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "(304,635)",
                "Variance": "304,635",
                "Variance %": "100%"
            },
            "block3": {
                "Actual": "(326,844)",
                "Budget": "(842,810)",
                "Variance": "515,967",
                "Variance %": "61.22%"
            },
            "block4": {
                "Actual": "(326,844)",
                "Budget": "-",
                "Variance": "(326,844)",
                "Variance %": "-"
            }
        },
        {
            "label": "Total Other Direct",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "(220,622)",
                "Variance": "220,622",
                "Variance %": "100%"
            },
            "block3": {
                "Actual": "(227,563)",
                "Budget": "(604,252)",
                "Variance": "376,689",
                "Variance %": "62.34%"
            },
            "block4": {
                "Actual": "(227,563)",
                "Budget": "-",
                "Variance": "(227,563)",
                "Variance %": "-"
            }
        },
        {
            "label": "EBITDA",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "3,376,761",
                "Variance": "(3,376,761)",
                "Variance %": "(100%)"
            },
            "block3": {
                "Actual": "3,806,253",
                "Budget": "10,756,252",
                "Variance": "(6,949,999)",
                "Variance %": "(64.61%)"
            },
            "block4": {
                "Actual": "3,806,253",
                "Budget": "-",
                "Variance": "3,806,253",
                "Variance %": "-"
            }
        },
        {
            "label": "EBITDA Margin",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "43.77%",
                "Variance": "-",
                "Variance %": "-"
            },
            "block3": {
                "Actual": "43.62%",
                "Budget": "44.59%",
                "Variance": "-",
                "Variance %": "(0.97%)"
            },
            "block4": {
                "Actual": "43.62%",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            }
        },
        {
            "label": "Total Depreciation & Amortization",
            "block1": {
                "Actual": "-",
                "Budget": "(1)",
                "Variance": "1",
                "Variance %": "100%"
            },
            "block2": {
                "Actual": "-",
                "Budget": "(49,466)",
                "Variance": "49,466",
                "Variance %": "100%"
            },
            "block3": {
                "Actual": "(21,749)",
                "Budget": "(120,088)",
                "Variance": "98,339",
                "Variance %": "81.89%"
            },
            "block4": {
                "Actual": "(21,749)",
                "Budget": "(2)",
                "Variance": "(21,747)",
                "Variance %": "(966,538.22%)"
            }
        },
        {
            "label": "Zakat, Exceptional & CG",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block3": {
                "Actual": "6,097",
                "Budget": "(331,590)",
                "Variance": "337,688",
                "Variance %": "101.84%"
            },
            "block4": {
                "Actual": "6,097",
                "Budget": "-",
                "Variance": "6,097",
                "Variance %": "-"
            }
        },
        {
            "label": "OPERATING PROFIT/(LOSS)",
            "block1": {
                "Actual": "-",
                "Budget": "(1)",
                "Variance": "1",
                "Variance %": "100%"
            },
            "block2": {
                "Actual": "-",
                "Budget": "3,327,295",
                "Variance": "(3,327,295)",
                "Variance %": "(100%)"
            },
            "block3": {
                "Actual": "3,790,601",
                "Budget": "10,304,574",
                "Variance": "(6,513,972)",
                "Variance %": "(63.21%)"
            },
            "block4": {
                "Actual": "3,790,601",
                "Budget": "(2)",
                "Variance": "3,790,604",
                "Variance %": "168,471,267.11%"
            }
        },
        {
            "label": "NET PROFIT MARGIN",
            "block1": {
                "Actual": "-",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            },
            "block2": {
                "Actual": "-",
                "Budget": "43.12%",
                "Variance": "-",
                "Variance %": "-"
            },
            "block3": {
                "Actual": "43.44%",
                "Budget": "42.71%",
                "Variance": "-",
                "Variance %": "0.73%"
            },
            "block4": {
                "Actual": "43.44%",
                "Budget": "-",
                "Variance": "-",
                "Variance %": "-"
            }
        }
    ],
    "is_cfo": true,
    "is_ai": true,
    "ai_prompt": "You are a CFO financial analyst.\n\nCONTEXT:\n- Contract: Jeddah Airport Contract\n- Year: 2026\n- Month: Mar\n\nTASK:\nWrite a SHORT CFO summary of the given financial data.\n\nNON-NEGOTIABLE OUTPUT FORMAT:\n- Output MUST contain BETWEEN 6 AND 7 bullet LINES.\n- Each bullet MUST be a SEPARATE LINE.\n- Each bullet MUST start with '- ' (dash then space).\n- DO NOT use numbering like 1), 2), 3) or 1. 2. 3.\n- DO NOT add any title or paragraph before/after bullets.\n- Do NOT use colons ':' inside bullets.\n\nBREVITY RULES (IMPORTANT):\n- Each bullet MUST be max 16 words.\n- Each bullet MUST be ONE sentence only.\n- Avoid detailed explanations.\n- Focus on high-level KPIs only.\n\nCONTENT RULES:\n- First bullet MUST mention Contract (Jeddah Airport Contract), Year (2026), Month (Mar).\n- Use ONLY labels present in the JSON.\n- Prefer these labels when available: Total Revenue, EBITDA, EBITDA Margin, Total Rent, OPERATING PROFIT/(LOSS), NET PROFIT MARGIN.\n- Do NOT include raw Budget values; mention variance direction only when needed.\n- Do NOT use the word 'Block'.\n\nNUMBER FORMAT RULES (STRICT):\n- BEFORE writing bullets, convert ALL numeric values:\n  - ≥1,000,000 → M (one decimal max)\n  - ≥1,000 → K (one decimal max)\n  - <1,000 → integer only\n- Raw numbers like 4949075 are STRICTLY FORBIDDEN.\n- Do NOT mix raw numbers with K/M/B.\n- Do NOT add currency symbols (no $, SAR, USD).\n- Values like (227,872) represent NEGATIVE numbers.\n\nINVALID EXAMPLE:\n- Total Revenue was 4949075.\n\nVALID EXAMPLE:\n- Total Revenue was 4.95M.\n\nSELF-CHECK (MANDATORY):\n- If ANY bullet violates rules, output EXACTLY: ERROR_RULES_NOT_MET\n\nIMPORTANT:\n- Any rule violation will cause the output to be rejected by an automated validator.\n\nRAW_DATA_JSON:\n{\"meta\":{\"contract\":\"Jeddah Airport Contract\",\"year\":\"2026\",\"month\":\"Mar\",\"measure\":0,\"type\":\"pnl_pageone\"},\"data\":[{\"label\":\"Revenue\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"}},{\"label\":\"DAILY PARKING\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"5,537,176\",\"Budget\":\"14,876,227\",\"Variance\":\"(9,339,051)\",\"Variance %\":\"(62.78%)\"}},{\"label\":\"Season Tickets\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"1,948,041\",\"Budget\":\"6,052,817\",\"Variance\":\"(4,104,776)\",\"Variance %\":\"(67.82%)\"}},{\"label\":\"Fines & Penalties\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"188,870\",\"Budget\":\"937,744\",\"Variance\":\"(748,874)\",\"Variance %\":\"(79.86%)\"}},{\"label\":\"Clamp & Removal\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"}},{\"label\":\"POUND\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"241,497\",\"Budget\":\"1,258,363\",\"Variance\":\"(1,016,866)\",\"Variance %\":\"(80.81%)\"}},{\"label\":\"OTHER INCOME\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"814,580\",\"Budget\":\"1,004,351\",\"Variance\":\"(189,771)\",\"Variance %\":\"(18.89%)\"}},{\"label\":\"CASH EXCESS \\/ (SHORT)\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"(4,422)\",\"Budget\":\"1,253\",\"Variance\":\"(5,675)\",\"Variance %\":\"(453.04%)\"}},{\"label\":\"Validations\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"}},{\"label\":\"Refunds\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"-\",\"Budget\":\"(6,239)\",\"Variance\":\"6,239\",\"Variance %\":\"100%\"}},{\"label\":\"WRAPPING BUSINESS\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"}},{\"label\":\"Total Revenue\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"8,725,742\",\"Budget\":\"24,124,516\",\"Variance\":\"(15,398,774)\",\"Variance %\":\"(63.83%)\"}},{\"label\":\"Total Rent\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"(4,365,082)\",\"Budget\":\"(11,921,201)\",\"Variance\":\"7,556,120\",\"Variance %\":\"63.38%\"}},{\"label\":\"Rent V Revenue %\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"50.03%\",\"Budget\":\"49.42%\",\"Variance\":\"-\",\"Variance %\":\"0.61%\"}},{\"label\":\"Staff Cost-Direct %\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"1.75%\",\"Budget\":\"1.59%\",\"Variance\":\"-\",\"Variance %\":\"0.16%\"}},{\"label\":\"Total Staff Cost - Direct\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"(326,844)\",\"Budget\":\"(842,810)\",\"Variance\":\"515,967\",\"Variance %\":\"61.22%\"}},{\"label\":\"Total Other Direct\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"(227,563)\",\"Budget\":\"(604,252)\",\"Variance\":\"376,689\",\"Variance %\":\"62.34%\"}},{\"label\":\"EBITDA\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"3,806,253\",\"Budget\":\"10,756,252\",\"Variance\":\"(6,949,999)\",\"Variance %\":\"(64.61%)\"}},{\"label\":\"EBITDA Margin\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"43.62%\",\"Budget\":\"44.59%\",\"Variance\":\"-\",\"Variance %\":\"(0.97%)\"}},{\"label\":\"Total Depreciation & Amortization\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"(1)\",\"Variance\":\"1\",\"Variance %\":\"100%\"},\"ytd\":{\"Actual\":\"(21,749)\",\"Budget\":\"(120,088)\",\"Variance\":\"98,339\",\"Variance %\":\"81.89%\"}},{\"label\":\"Zakat, Exceptional & CG\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"6,097\",\"Budget\":\"(331,590)\",\"Variance\":\"337,688\",\"Variance %\":\"101.84%\"}},{\"label\":\"OPERATING PROFIT\\/(LOSS)\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"(1)\",\"Variance\":\"1\",\"Variance %\":\"100%\"},\"ytd\":{\"Actual\":\"3,790,601\",\"Budget\":\"10,304,574\",\"Variance\":\"(6,513,972)\",\"Variance %\":\"(63.21%)\"}},{\"label\":\"NET PROFIT MARGIN\",\"mtd\":{\"Actual\":\"-\",\"Budget\":\"-\",\"Variance\":\"-\",\"Variance %\":\"-\"},\"ytd\":{\"Actual\":\"43.44%\",\"Budget\":\"42.71%\",\"Variance\":\"-\",\"Variance %\":\"0.73%\"}}]}",
    "ai_summary": "- Jeddah Airport Contract (2026, Mar): Total Revenue was 8.73M, down 63.83% from Budget.\n- EBITDA was 3.81M, a 64.61% decrease compared to Budget.\n- EBITDA Margin was 43.62%, slightly lower than Budget's 44.59%.\n- Total Rent was (4.37M), an increase of 63.38% versus Budget.\n- Rent vs Revenue percentage increased to 50.03% from Budget's 49.42%.\n- Operating Profit was (6.51M), a 63.21% decrease compared to Budget.\n- Net Profit Margin was 43.44%, higher than Budget's 42.71%.",
    "lines": [
        "- Jeddah Airport Contract (2026, Mar): Total Revenue was 8.73M, down 63.83% from Budget.",
        "- EBITDA was 3.81M, a 64.61% decrease compared to Budget.",
        "- EBITDA Margin was 43.62%, slightly lower than Budget's 44.59%.",
        "- Total Rent was (4.37M), an increase of 63.38% versus Budget.",
        "- Rent vs Revenue percentage increased to 50.03% from Budget's 49.42%.",
        "- Operating Profit was (6.51M), a 63.21% decrease compared to Budget.",
        "- Net Profit Margin was 43.44%, higher than Budget's 42.71%."
    ]
};


      const { meta, data: apiRows } = response;
      if (response?.ai_summary || response?.lines) {
        setSummary({
          ai_summary: response?.ai_summary,
          lines: response?.lines,
        });
      }

      // Fixed column structure (matches your original layout)
      const columns = [
        { year: meta.year, period: meta.month, type: "Actual" },
        { year: meta.year, period: meta.month, type: "Budget" },
        { year: meta.year, period: meta.month, type: "Variance Act V Bud" },
        { year: meta.year, period: meta.month, type: "% Variance Act V Bud" },
        { year: meta.year, period: meta.month, type: "Actual" },
        { year: meta.previousYear, period: meta.month, type: "Actual" },
        {
          year: `${meta.year} v ${meta.previousYear}`,
          period: meta.month,
          type: "Variance",
        },
        {
          year: `${meta.year} v ${meta.previousYear}`,
          period: meta.month,
          type: "% Variance",
        },
        {
          year: meta.year,
          period: `${meta.month} YTD`,
          type: "Actual",
          isYTD: true,
        },
        {
          year: meta.previousYear,
          period: `${meta.month} YTD`,
          type: "Actual",
          isYTD: true,
        },
        {
          year: `${meta.year} v ${meta.previousYear}`,
          period: `${meta.month} YTD`,
          type: "Variance",
          isYTD: true,
        },
        {
          year: `${meta.year} v ${meta.previousYear}`,
          period: `${meta.month} YTD`,
          type: "% Variance",
          isYTD: true,
        },
        {
          year: meta.year,
          period: `${meta.month} YTD`,
          type: "Actual",
          isYTD: true,
        },
        {
          year: meta.year,
          period: `${meta.month} YTD`,
          type: "Budget",
          isYTD: true,
        },
        {
          year: meta.year,
          period: `${meta.month} YTD`,
          type: "Variance Act V Bud",
          isYTD: true,
        },
        {
          year: meta.year,
          period: `${meta.month} YTD`,
          type: "% Variance Act V Bud",
          isYTD: true,
        },
      ];

      // Transform API response to table rows format
      const transformedRows = apiRows.map((item) => {
        const isTotal =
          item.label === "Total Revenue" ||
          item.label === "EBITDA" ||
          item.label === "OPERATING PROFIT/(LOSS)";

        const isSectionHeader =
          item.label === "Revenue" ||
          item.label === "Total Rent" ||
          item.label === "Zakat, Exceptional & CG" ||
          item.label === "Total Depreciation & Amortization";

        return {
          label: item.label,
          values: [
            item.block1.Actual || "-",
            item.block1.Budget || "-",
            item.block1.Variance || "-",
            item.block1["Variance %"] || "-",

            item.block2.Actual || "-",
            item.block2.Budget || "-",
            item.block2.Variance || "-",
            item.block2["Variance %"] || "-",

            item.block3.Actual || "-",
            item.block3.Budget || "-",
            item.block3.Variance || "-",
            item.block3["Variance %"] || "-",

            item.block4.Actual || "-",
            item.block4.Budget || "-",
            item.block4.Variance || "-",
            item.block4["Variance %"] || "-",
          ],
          isTotal,
          isSectionHeader,
        };
      });

      setTableData({
        columns,
        rows: transformedRows,
      });
    } catch (err) {
      console.error("Profit & Loss fetch error:", err);
      setError(err.message || "Failed to load data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  // ────────────────────────────────────────────────
  // Render states
  // ────────────────────────────────────────────────

  if (loading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorState error={error} onRetry={fetchData} />;
  }

  return (
    <div className="relative w-full min-h-screen flex flex-col pb-12">
      <div className="px-4 " style={{ zoom: summary?.lines?.length > 0 ? "100%" : "100%" }}>
        <TableCurrentMonthYear
          title={page?.title}
          subtitle={page?.subtitle}
          columns={tableData.columns}
          rows={tableData.rows}
          isCFO={false}
        />
      </div>
    </div>
  );
}

export default MainTable;
